// extracted by mini-css-extract-plugin
export default {"version":"VersionInfo_version__M6HxC"};